(async () => {
  const baseComponent = await import(window.theme.modules.baseComponent);

  customElements.define(
    "main-header",
    class extends baseComponent.default {
      elements = {
        nav: "main-nav",
      };

      render() {
        this.on("stickyMainHeader", (e, { sticky }) => {
          if (sticky) {
            this.classList.add("@sticky");
            document.body.style.setProperty(
              "--sticky-header-offset",
              `${this.offsetHeight}px`,
            );
          } else {
            this.classList.remove("@sticky");
            document.body.style.setProperty("--sticky-header-offset", "0");
          }
        });
      }
    },
  );
})();
